function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _excluded = ["children", "linkAttribute", "linkComponent", "from", "viewMode", "setViewMode", "handleFullScreen", "prevPageLink"],
  _excluded2 = ["menus", "header", "organisationSettings", "organisationMenuList", "organisationId", "teamId", "user", "organisationTeamAndRole", "from", "viewMode", "handleFullScreen", "manualTimeCount", "role", "menuType", "organisationBilling", "moblieSideMenu", "windowSize", "organisationDetailsLoading", "organisationTeamLoading", "leaveSettingsApprovedData", "organisationStatus"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw new Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw new Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import { useQuery, useMutation, useLazyQuery } from "@apollo/client";
import classNames from "classnames";
import { default as DropdownMenu, Divider as DropdownDivider, MenuItem as DropdownMenuItem, SubMenu as DropdownSubMenu } from "rc-menu";
import "rc-menu/assets/index.css";
import React, { useCallback, useContext, useEffect, useMemo, useState } from "react";
import Dropdown from "react-bootstrap/Dropdown";
import Button from "react-bootstrap/Button";
import Spinner from "react-bootstrap/Spinner";
import { Helmet } from "react-helmet";
import { FilterContext, SearchContext, UserContext, TrackingContext } from "../index";
import { toCamel } from "../utils";
import { personalDataTabs } from "./data";
import Header, { CustomToggle } from "./Header";
import { desktopMenu as desktopMenus, webMenu as webMenus, webSecondMenu as webSecondMenus, webUserMenu as webUserMenus } from "./menu";
import { WEB_ORGANISATION_SETTINGS_QUERY, GET_ORGANISATION_SETTINGS_QUERY, ORGANISATION_DETAILS_QUERY, ORGANISATION_TEAMS_QUERY, USER_TOUR_STATUS_QUERY, UPDATE_TOUR_MUTATION, USER_ROLES_QUERY } from "./query";
import { LEAVE_SETTINGS_APPROVED_LIST_QUERY } from "./../LeaveSettings/query";
import { GET_REVIEW_MANUAL_TIME_COUNT_QUERY } from "./../ManualTimeEntriesReview/query";
import "./SideMenu.css";
import moment from "moment-timezone";
import Tour from "reactour";
import { tourStepsForAdmin, tourStepsForHead } from "./TourStep";
import { findIsWorkfolioSite } from "../utils";
import jwtDecode from "jwt-decode";
import { GoThreeBars } from "react-icons/go";
import Loader from "./../Loader/Loader";
import { startOfDayCheck, endOfDayCheck } from "./Header";
moment.tz.setDefault(moment.tz.guess());
function findMenu(arr, key, match) {
  var _arr$map, _arr$map$flat;
  return (_arr$map = arr.map(function (m) {
    return m.menu;
  })) === null || _arr$map === void 0 ? void 0 : (_arr$map$flat = _arr$map.flat()) === null || _arr$map$flat === void 0 ? void 0 : _arr$map$flat.find(function (m) {
    return m[key] === match;
  });
}
var Sidemenu = function Sidemenu(props) {
  var _organisationDetailsD3, _organisationDetailsD4, _organisationDetailsD5, _organisationDetailsD6, _manualTimeCountData$, _manualTimeCountData$2;
  var children = props.children,
    linkAttribute = props.linkAttribute,
    LinkComponent = props.linkComponent,
    _props$from = props.from,
    from = _props$from === void 0 ? "web" : _props$from,
    viewMode = props.viewMode,
    setViewMode = props.setViewMode,
    handleFullScreen = props.handleFullScreen,
    prevPageLink = props.prevPageLink,
    otherProps = _objectWithoutProperties(props, _excluded);
  var history = props.history;
  var tracking = React.useContext(TrackingContext);
  var _ref = tracking || {},
    task = _ref.task,
    onStop = _ref.onStop;
  var _React$useState = React.useState(isWindow ? 1200 : window.innerWidth),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    windowSize = _React$useState2[0],
    setWindowSize = _React$useState2[1];
  var _React$useState3 = React.useState(true),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    mobileViewSideMenu = _React$useState4[0],
    setMobileViewSideMenu = _React$useState4[1];
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    role = _useState2[0],
    setRole = _useState2[1];
  var _useState3 = useState(null),
    _useState4 = _slicedToArray(_useState3, 2),
    organisationSettings = _useState4[0],
    setOrganisationSettings = _useState4[1];
  var _useState5 = useState(null),
    _useState6 = _slicedToArray(_useState5, 2),
    leaveSettingsUser = _useState6[0],
    setLeaveSettingsUser = _useState6[1];
  var _useState7 = useState(null),
    _useState8 = _slicedToArray(_useState7, 2),
    organisationId = _useState8[0],
    setOrganisationId = _useState8[1];
  var _useState9 = useState({
      planStatus: "active",
      stoppedReason: null
    }),
    _useState10 = _slicedToArray(_useState9, 2),
    planStatusDetails = _useState10[0],
    setPlanStatusDetails = _useState10[1];
  var _useState11 = useState([]),
    _useState12 = _slicedToArray(_useState11, 2),
    organisationMenuList = _useState12[0],
    setOganisationMenuList = _useState12[1];
  var _useState13 = useState(0),
    _useState14 = _slicedToArray(_useState13, 2),
    organisationUserCount = _useState14[0],
    setOrganisationUserCount = _useState14[1];
  var _useState15 = useState([]),
    _useState16 = _slicedToArray(_useState15, 2),
    organisationBilling = _useState16[0],
    setOrganisationBilling = _useState16[1];
  var _useState17 = useState("active"),
    _useState18 = _slicedToArray(_useState17, 2),
    organisationStatus = _useState18[0],
    setOrganisationStatus = _useState18[1];
  var _useState19 = useState(null),
    _useState20 = _slicedToArray(_useState19, 2),
    teamId = _useState20[0],
    setTeamId = _useState20[1];
  var _useState21 = useState("All Team"),
    _useState22 = _slicedToArray(_useState21, 2),
    teamName = _useState22[0],
    setTeamName = _useState22[1];
  var _useState23 = useState(null),
    _useState24 = _slicedToArray(_useState23, 2),
    showSecondMenu = _useState24[0],
    setSecondMenu = _useState24[1];
  var _useState25 = useState({
      firstMenu: null,
      secondMenu: null,
      pageHeader: null
    }),
    _useState26 = _slicedToArray(_useState25, 2),
    activeMenus = _useState26[0],
    setActiveMenus = _useState26[1];
  var _useState27 = useState(false),
    _useState28 = _slicedToArray(_useState27, 2),
    fetchError = _useState28[0],
    setFetchError = _useState28[1];

  //projectManagementFeature

  var currentTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  var todayDate = moment().toDate();
  var _useState29 = useState({
      startDate: todayDate,
      endDate: null
    }),
    _useState30 = _slicedToArray(_useState29, 2),
    dates = _useState30[0],
    setDates = _useState30[1];
  var _useState31 = useState(localStorage.getItem("timezone")),
    _useState32 = _slicedToArray(_useState31, 2),
    timezoneFilter = _useState32[0],
    setTimezoneFilter = _useState32[1];
  var _useState33 = useState(""),
    _useState34 = _slicedToArray(_useState33, 2),
    search = _useState34[0],
    setSearch = _useState34[1];
  var _useState35 = useState(false),
    _useState36 = _slicedToArray(_useState35, 2),
    isTourOpen = _useState36[0],
    setIsTourOpen = _useState36[1];
  var linkProps = {
    linkAttribute: linkAttribute,
    linkComponent: LinkComponent
  };
  var _useContext = useContext(UserContext),
    user = _useContext.user;
  var menuMapping = useMemo(function () {
    if (from === "web") {
      return {
        menus: webMenus,
        secondMenus: webSecondMenus
      };
    }
    return {
      menus: desktopMenus,
      secondMenus: {}
    };
  }, []);
  var menus = menuMapping.menus,
    secondMenus = menuMapping.secondMenus;
  var handleStop = function handleStop(activity) {
    return function () {
      if (!task) return;
      onStop === null || onStop === void 0 ? void 0 : onStop(activity);
    };
  };
  var isWindow = typeof window !== "undefined";
  function changeWindowSize() {
    setWindowSize(window.innerWidth);
  }
  React.useEffect(function () {
    if (window.innerWidth > 768 && isWindow && from === "web") {
      setMobileViewSideMenu(true);
    } else {
      setMobileViewSideMenu(false);
    }
    window.addEventListener("resize", changeWindowSize);
    return function () {
      window.removeEventListener("resize", changeWindowSize);
    };
  }, []);
  useEffect(function () {
    var _otherProps$location, _otherProps$location$3;
    var _otherProps$location$ = otherProps === null || otherProps === void 0 ? void 0 : (_otherProps$location = otherProps.location) === null || _otherProps$location === void 0 ? void 0 : (_otherProps$location$3 = _otherProps$location.pathname) === null || _otherProps$location$3 === void 0 ? void 0 : _otherProps$location$3.split("/"),
      _otherProps$location$2 = _slicedToArray(_otherProps$location$, 3),
      _ = _otherProps$location$2[0],
      firstMenu = _otherProps$location$2[1],
      secondMenu = _otherProps$location$2[2];
    var pageHeader = "";
    if (secondMenus[firstMenu]) {
      var _findMenu;
      pageHeader = (_findMenu = findMenu(secondMenus[firstMenu], "path", secondMenu)) === null || _findMenu === void 0 ? void 0 : _findMenu.name;
      setSecondMenu(firstMenu);
    } else {
      var _findMenu2;
      pageHeader = (_findMenu2 = findMenu(menus, "path", firstMenu)) === null || _findMenu2 === void 0 ? void 0 : _findMenu2.name;
      setSecondMenu(null);
    }
    setActiveMenus(function (prev) {
      return _objectSpread(_objectSpread({}, prev), {}, {
        firstMenu: firstMenu,
        secondMenu: secondMenu,
        pageHeader: pageHeader
      });
    });
  }, [otherProps.location]);
  var setDatesFilter = useCallback(function (dates) {
    setDates(dates);
  }, []);
  React.useEffect(function () {
    if (organisationSettings !== null && organisationSettings !== void 0 && organisationSettings.organisationTimezone) {
      var todayTemp = moment().tz(currentTimezone).clone().startOf("days").toDate();
      if (startOfDayCheck(currentTimezone, organisationSettings === null || organisationSettings === void 0 ? void 0 : organisationSettings.organisationTimezone)) {
        todayTemp = moment().tz(currentTimezone).clone().startOf("days").toDate();
      } else if (endOfDayCheck(currentTimezone, organisationSettings === null || organisationSettings === void 0 ? void 0 : organisationSettings.organisationTimezone)) {
        todayTemp = moment().tz(currentTimezone).clone().endOf("days").toDate();
      } else {
        todayTemp = moment().tz(currentTimezone).clone().toDate();
      }

      // console.log({ todayTemp });

      setDates({
        startDate: todayTemp,
        endDate: null
      });
    }
  }, [organisationSettings]);

  //  WORKFOLIO MAINTENANCE REDIRECTION
  // React.useEffect(() => {
  //   props?.history.push("/workfolio-maintenance");
  // }, []);

  var _useQuery = useQuery(ORGANISATION_DETAILS_QUERY, {
      variables: {
        userId: user.userId,
        from: from
      },
      skip: !user.userId,
      fetchPolicy: from === "web" ? "network-only" : "cache-first"
    }),
    organisationDetailsData = _useQuery.data,
    organisationDetailsError = _useQuery.error,
    organisationDetailsLoading = _useQuery.loading,
    organisationDetailsRefetch = _useQuery.refetch;
  React.useEffect(function () {
    organisationDetailsRefetch === null || organisationDetailsRefetch === void 0 ? void 0 : organisationDetailsRefetch();
  }, [props.location.key]);
  var _useQuery2 = useQuery(GET_REVIEW_MANUAL_TIME_COUNT_QUERY, {
      variables: {
        organisationId: organisationId,
        teamId: teamId
      },
      skip: !organisationId || !teamId || from !== "web"
    }),
    manualTimeCountData = _useQuery2.data,
    manualTimeCountError = _useQuery2.error;
  useEffect(function () {
    if (organisationDetailsData !== null && organisationDetailsData !== void 0 && organisationDetailsData.organisationDetails) {
      try {
        var _window, _window$ipcRenderer, _organisationDetailsD, _organisationDetailsD2;
        setOrganisationId(organisationDetailsData.organisationDetails[0].organisationId);
        setOganisationMenuList(organisationDetailsData.organisationDetails[0].menuDetails);
        setOrganisationUserCount(organisationDetailsData.organisationDetails[0].userCount);
        setOrganisationBilling(organisationDetailsData.organisationDetails[0].billing);
        setPlanStatusDetails({
          planStatus: organisationDetailsData.organisationDetails[0].billing.planStatus,
          stoppedReason: organisationDetailsData.organisationDetails[0].billing.stoppedReason
        });
        setOrganisationStatus(organisationDetailsData.organisationDetails[0].organisationStatus);
        (_window = window) === null || _window === void 0 ? void 0 : (_window$ipcRenderer = _window.ipcRenderer) === null || _window$ipcRenderer === void 0 ? void 0 : _window$ipcRenderer.invoke("set_store_value", {
          planType: organisationDetailsData === null || organisationDetailsData === void 0 ? void 0 : (_organisationDetailsD = organisationDetailsData.organisationDetails[0]) === null || _organisationDetailsD === void 0 ? void 0 : (_organisationDetailsD2 = _organisationDetailsD.billing) === null || _organisationDetailsD2 === void 0 ? void 0 : _organisationDetailsD2.planName
        });
      } catch (error) {
        setFetchError(true);
      }
    }
  }, [organisationDetailsData === null || organisationDetailsData === void 0 ? void 0 : organisationDetailsData.organisationDetails]);
  useEffect(function () {
    setSearch("");
  }, [activeMenus]);

  // USER_TOUR_STATUS_QUERY

  var _useLazyQuery = useLazyQuery(USER_TOUR_STATUS_QUERY, {
      variables: {
        userId: user.userId
      },
      fetchPolicy: from === "web" ? "network-only" : "cache-first",
      skip: from !== "web" || (user === null || user === void 0 ? void 0 : user.tourStatus) && (user === null || user === void 0 ? void 0 : user.tourStatus) == "completed" || !user.userId
    }),
    _useLazyQuery2 = _slicedToArray(_useLazyQuery, 2),
    getUserTourStatus = _useLazyQuery2[0],
    _useLazyQuery2$ = _useLazyQuery2[1],
    userTourStatusData = _useLazyQuery2$.data,
    userTourStatusError = _useLazyQuery2$.error,
    userTourStatusLoading = _useLazyQuery2$.loading;
  React.useEffect(function () {
    if (from === "web" && (!(user !== null && user !== void 0 && user.tourStatus) || (user === null || user === void 0 ? void 0 : user.tourStatus) != "completed")) {
      getUserTourStatus();
    }
  }, [props.location.key]);
  useEffect(function () {
    if (userTourStatusLoading) return;
    if (userTourStatusData == undefined) return;
    if (from === "web" && (user === null || user === void 0 ? void 0 : user.tourStatus) != "completed") {
      var tokenData = jwtDecode(userTourStatusData === null || userTourStatusData === void 0 ? void 0 : userTourStatusData.userTourStatus);
      if (tokenData) {
        var _localStorage, _localStorage$setItem, _user$setUser;
        (_localStorage = localStorage) === null || _localStorage === void 0 ? void 0 : (_localStorage$setItem = _localStorage.setItem) === null || _localStorage$setItem === void 0 ? void 0 : _localStorage$setItem.call(_localStorage, "token", userTourStatusData === null || userTourStatusData === void 0 ? void 0 : userTourStatusData.userTourStatus);
        user === null || user === void 0 ? void 0 : (_user$setUser = user.setUser) === null || _user$setUser === void 0 ? void 0 : _user$setUser.call(user, jwtDecode(tokenData));
      }
      setIsTourOpen((tokenData === null || tokenData === void 0 ? void 0 : tokenData.tourStatus) === null ? true : false);
    } else if (from === "web" && (user === null || user === void 0 ? void 0 : user.tourStatus) == "completed") {
      setIsTourOpen(false);
    }
  }, [userTourStatusData]);
  var _useQuery3 = useQuery(from === "desktop" ? GET_ORGANISATION_SETTINGS_QUERY : WEB_ORGANISATION_SETTINGS_QUERY, {
      variables: {
        organisationId: organisationId || (organisationDetailsData === null || organisationDetailsData === void 0 ? void 0 : (_organisationDetailsD3 = organisationDetailsData.organisationDetails[0]) === null || _organisationDetailsD3 === void 0 ? void 0 : _organisationDetailsD3.organisationId)
      },
      skip: !organisationId || !(organisationDetailsData !== null && organisationDetailsData !== void 0 && (_organisationDetailsD4 = organisationDetailsData.organisationDetails[0]) !== null && _organisationDetailsD4 !== void 0 && _organisationDetailsD4.organisationId),
      fetchPolicy: from === "web" ? "network-only" : "cache-first"
    }),
    organisationSettingsData = _useQuery3.data,
    organisationSettingsError = _useQuery3.error,
    organisationSettingsLoading = _useQuery3.loading,
    organisationSettingsRefetch = _useQuery3.refetch;
  var _useQuery4 = useQuery(LEAVE_SETTINGS_APPROVED_LIST_QUERY, {
      variables: {
        organisationId: organisationId || (organisationDetailsData === null || organisationDetailsData === void 0 ? void 0 : (_organisationDetailsD5 = organisationDetailsData.organisationDetails[0]) === null || _organisationDetailsD5 === void 0 ? void 0 : _organisationDetailsD5.organisationId)
      },
      skip: !organisationId || !(organisationDetailsData !== null && organisationDetailsData !== void 0 && (_organisationDetailsD6 = organisationDetailsData.organisationDetails[0]) !== null && _organisationDetailsD6 !== void 0 && _organisationDetailsD6.organisationId),
      fetchPolicy: from === "web" ? "network-only" : "cache-first"
    }),
    leaveSettingsApprovedData = _useQuery4.data,
    leaveSettingsApprovedError = _useQuery4.error,
    leaveSettingsApprovedLoading = _useQuery4.loading,
    leaveSettingRefetch = _useQuery4.refetch;
  var _useQuery5 = useQuery(ORGANISATION_TEAMS_QUERY, {
      variables: {
        organisationId: organisationId,
        from: from === "web" ? "web" : null
      },
      skip: !organisationId,
      fetchPolicy: from === "web" ? "network-only" : "cache-first"
    }),
    organisationTeamData = _useQuery5.data,
    organisationTeamLoading = _useQuery5.loading,
    organisationTeamError = _useQuery5.error,
    organisationTeamRefetch = _useQuery5.refetch;
  useEffect(function () {
    if (organisationTeamLoading) return;
    if (organisationTeamData !== null && organisationTeamData !== void 0 && organisationTeamData.organisationTeams && !teamId || organisationTeamData !== null && organisationTeamData !== void 0 && organisationTeamData.organisationTeams && prevPageLink === "/login") {
      var _organisationTeamData, _organisationTeamData2, _organisationTeamData3, _organisationTeamData4, _organisationTeamData5, _organisationTeamData6, _organisationTeamData7, _organisationTeamData8;
      setTeamId((organisationTeamData === null || organisationTeamData === void 0 ? void 0 : organisationTeamData.organisationTeams.length) > 1 && from === "web" ? "all" : (task === null || task === void 0 ? void 0 : task.teamId) || (organisationTeamData === null || organisationTeamData === void 0 ? void 0 : (_organisationTeamData = organisationTeamData.organisationTeams) === null || _organisationTeamData === void 0 ? void 0 : (_organisationTeamData2 = _organisationTeamData[0]) === null || _organisationTeamData2 === void 0 ? void 0 : _organisationTeamData2.teamId));
      setTeamName((organisationTeamData === null || organisationTeamData === void 0 ? void 0 : organisationTeamData.organisationTeams.length) > 1 && from === "web" ? "All Team" : (task === null || task === void 0 ? void 0 : task.teamId) || (organisationTeamData === null || organisationTeamData === void 0 ? void 0 : (_organisationTeamData3 = organisationTeamData.organisationTeams) === null || _organisationTeamData3 === void 0 ? void 0 : (_organisationTeamData4 = _organisationTeamData3[0]) === null || _organisationTeamData4 === void 0 ? void 0 : _organisationTeamData4.teamName));

      // const teamDetails =
      //   organisationTeamData?.organisationTeams.find(
      //     (teamData) => teamData.teamId === organisationTeamData?.organisationTeams?.[0]?.teamId
      //   ) || {};

      // let roles = teamDetails?.roleName === undefined ? null : teamDetails?.roleName;

      var roles = (organisationTeamData === null || organisationTeamData === void 0 ? void 0 : (_organisationTeamData5 = organisationTeamData.organisationTeams) === null || _organisationTeamData5 === void 0 ? void 0 : _organisationTeamData5.length) <= 1 ? organisationTeamData === null || organisationTeamData === void 0 ? void 0 : (_organisationTeamData6 = organisationTeamData.organisationTeams) === null || _organisationTeamData6 === void 0 ? void 0 : (_organisationTeamData7 = _organisationTeamData6[0]) === null || _organisationTeamData7 === void 0 ? void 0 : _organisationTeamData7.roleName : null;
      if ((organisationTeamData === null || organisationTeamData === void 0 ? void 0 : (_organisationTeamData8 = organisationTeamData.organisationTeams) === null || _organisationTeamData8 === void 0 ? void 0 : _organisationTeamData8.length) > 1 && roles == null) {
        var adminCheck = organisationTeamData === null || organisationTeamData === void 0 ? void 0 : organisationTeamData.organisationTeams.some(function (team) {
          return team.roleName === "Admin";
        });
        var headCheck = organisationTeamData === null || organisationTeamData === void 0 ? void 0 : organisationTeamData.organisationTeams.some(function (team) {
          return team.roleName === "Head";
        });
        roles = adminCheck ? "Admin" : headCheck ? "Head" : (organisationTeamData === null || organisationTeamData === void 0 ? void 0 : organisationTeamData.organisationTeams) === undefined ? null : "Member";
      }
      setRole(roles);
    }
  }, [organisationTeamData === null || organisationTeamData === void 0 ? void 0 : organisationTeamData.organisationTeams]);

  // menuMapping = useMemo(() => {

  //   if (from === "web" && role == "Member") {

  //     return { menus: webUserMenus, secondMenus: {} };
  //   }
  //   return { menus: desktopMenus, secondMenus: {} };
  // }, [role]);

  // const { menus, secondMenus } = menuMapping;

  useEffect(function () {
    if (isTourOpen && from === "web" && (role == "Admin" || role == "Head")) {
      props === null || props === void 0 ? void 0 : props.history.push("/settings/manage-employees");
    }
  }, [organisationTeamData === null || organisationTeamData === void 0 ? void 0 : organisationTeamData.organisationTeams]);
  var _useLazyQuery3 = useLazyQuery(USER_ROLES_QUERY, {
      variables: {
        organisationId: organisationId
      },
      skip: from !== "web" || !organisationId,
      fetchPolicy: from === "web" ? "network-only" : "cache-first"
    }),
    _useLazyQuery4 = _slicedToArray(_useLazyQuery3, 2),
    getRoleData = _useLazyQuery4[0],
    _useLazyQuery4$ = _useLazyQuery4[1],
    rolesData = _useLazyQuery4$.data,
    rolesError = _useLazyQuery4$.error,
    rolesLoading = _useLazyQuery4$.loading;
  var rolesDetails = !rolesLoading && !rolesError ? rolesData === null || rolesData === void 0 ? void 0 : rolesData.userRoles : null;
  useEffect(function () {
    if (organisationSettingsLoading) return;
    var organisationSettings = (organisationSettingsData === null || organisationSettingsData === void 0 ? void 0 : organisationSettingsData.getOrganisationSettings) || (organisationSettingsData === null || organisationSettingsData === void 0 ? void 0 : organisationSettingsData.webOrganisationSettings);
    if (!organisationSettings) return;
    var orgSettings = organisationSettings.reduce(function (acc, curr) {
      var val = curr.value;
      if (curr.valueType === "boolean") {
        val = curr.value === "true";
      }
      if (curr.valueType === "number") {
        val = Number(curr.value);
      }
      acc[toCamel(curr.featureName)] = val;
      return acc;
    }, {});
    setOrganisationSettings(orgSettings);

    // TIMEZONE FOR WORKFOLIO APP
    moment.tz.setDefault(orgSettings ? orgSettings.organisationTimezone : "America/Los_Angeles");
  }, [organisationSettingsData]);
  useEffect(function () {
    if (leaveSettingsApprovedLoading) return;
    var leaveSettings = leaveSettingsApprovedData === null || leaveSettingsApprovedData === void 0 ? void 0 : leaveSettingsApprovedData.leaveSettingsApprovedUserList;
    if (!leaveSettings) return;
    setLeaveSettingsUser(leaveSettings);
  }, [leaveSettingsApprovedData]);

  // leaveSettingsUser, setLeaveSettingsUser

  React.useEffect(function () {
    if (prevPageLink === "/login" && organisationId !== null) {
      organisationDetailsRefetch === null || organisationDetailsRefetch === void 0 ? void 0 : organisationDetailsRefetch();
      organisationTeamRefetch === null || organisationTeamRefetch === void 0 ? void 0 : organisationTeamRefetch();
      // organisationTeamAndRoleRefetch?.();
      organisationSettingsRefetch === null || organisationSettingsRefetch === void 0 ? void 0 : organisationSettingsRefetch();
      // rolesRefetch?.();
      // reviewAppsCountRefetch?.();
      leaveSettingRefetch === null || leaveSettingRefetch === void 0 ? void 0 : leaveSettingRefetch();
    }
  }, [prevPageLink, organisationId]);

  // UPDATE_TOUR_MUTATION
  var _useMutation = useMutation(UPDATE_TOUR_MUTATION),
    _useMutation2 = _slicedToArray(_useMutation, 2),
    updateUserTour = _useMutation2[0],
    updating = _useMutation2[1].loading;
  var userTourStop = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(userId) {
      var tourResponse;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            if (!updating) {
              _context.next = 2;
              break;
            }
            return _context.abrupt("return");
          case 2:
            _context.prev = 2;
            _context.next = 5;
            return updateUserTour({
              variables: {
                userId: userId
              }
            });
          case 5:
            tourResponse = _context.sent;
            setIsTourOpen(tourResponse.data.updateUserTour ? false : true);
            _context.next = 11;
            break;
          case 9:
            _context.prev = 9;
            _context.t0 = _context["catch"](2);
          case 11:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[2, 9]]);
    }));
    return function userTourStop(_x) {
      return _ref2.apply(this, arguments);
    };
  }();
  var firstMenu = activeMenus.firstMenu,
    secondMenu = activeMenus.secondMenu,
    pageHeader = activeMenus.pageHeader;
  var _ref3 = dates || {},
    startDate = _ref3.startDate,
    endDate = _ref3.endDate;
  var organisationTeams = organisationTeamData ? organisationTeamData.organisationTeams : [];
  if (role === "Head" && firstMenu === "settings" && secondMenu === "manage-teams") {
    secondMenu = "manage-employees";
    pageHeader = "Manage Employees";
  }
  if (organisationSettingsLoading || from === "web" && !organisationSettings) {
    return /*#__PURE__*/React.createElement("div", {
      style: {
        display: "grid",
        placeItems: "center",
        height: "100vh"
      }
    }, /*#__PURE__*/React.createElement(Spinner, {
      variant: "primary",
      animation: "border",
      role: "status"
    }, /*#__PURE__*/React.createElement("span", {
      className: "sr-only"
    }, "Loading...")));
  }

  // const isMobileView = windowSize < 768;
  var isMobileView = windowSize < 822;
  var moblieSideMenu = /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(names) {
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            if (isMobileView) {
              if (names === "Settings") {
                setMobileViewSideMenu(true);
              } else {
                setMobileViewSideMenu(mobileViewSideMenu ? false : true);
              }
            }
          case 1:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return function moblieSideMenu(_x2) {
      return _ref4.apply(this, arguments);
    };
  }();
  if (from === "desktop" && !organisationSettingsLoading && !organisationSettings) {
    if (organisationDetailsError || userTourStatusError || organisationTeamError || rolesError || organisationSettingsError || fetchError) {
      var _window2, _window2$ipcRenderer;
      var sendConsoleEvent = (_window2 = window) === null || _window2 === void 0 ? void 0 : (_window2$ipcRenderer = _window2.ipcRenderer) === null || _window2$ipcRenderer === void 0 ? void 0 : _window2$ipcRenderer.send("send_console_event", "Side Menu Query Error logged");
      return /*#__PURE__*/React.createElement("div", {
        id: "app-root"
      }, /*#__PURE__*/React.createElement("div", {
        style: {
          display: "grid",
          placeItems: "center",
          height: "90vh"
        }
      }, fetchError ? /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("img", {
        src: require("../img/under_maintenance.png"),
        style: {
          width: "100%"
        }
      }), /*#__PURE__*/React.createElement("p", {
        style: {
          textAlign: "center"
        }
      }, " ", /*#__PURE__*/React.createElement("b", null, "Your organization's workfolio account is deactivated."), " ", /*#__PURE__*/React.createElement("br", null), "Kindly contact workfolio admin in your company for more info.", /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("a", {
        onClick: function onClick() {
          return window.ipcRenderer.send("reload_application");
        },
        style: {
          cursor: "pointer"
        }
      }, /*#__PURE__*/React.createElement("b", null, "Click here")), " ", "to restart Workfolio. ", /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("br", null), "If this issue persists,", /*#__PURE__*/React.createElement("br", null), "Click on the need help button at the bottom.")) : /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("img", {
        src: require("../img/under_maintenance.png"),
        style: window.innerHeight > 1000 ? {
          width: "100%"
        } : {
          width: "77%",
          marginLeft: "12%"
        }
      }), /*#__PURE__*/React.createElement("p", {
        style: {
          textAlign: "center"
        }
      }, " ", /*#__PURE__*/React.createElement("b", null, "We are unable to reach our servers."), " ", /*#__PURE__*/React.createElement("br", null), "Check your internet connection and try again.", /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("a", {
        onClick: function onClick() {
          return window.ipcRenderer.send("reload_application");
        },
        style: {
          cursor: "pointer"
        }
      }, /*#__PURE__*/React.createElement("b", null, "Click here")), " ", "to restart Workfolio. ", /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("br", null), "If this issue persists,", /*#__PURE__*/React.createElement("br", null), "Click on the need help button at the bottom."))), /*#__PURE__*/React.createElement("p", {
        style: {
          top: 40,
          right: 20,
          position: "fixed",
          cursor: "pointer",
          textDecoration: "underline"
        },
        onClick: function onClick() {
          return window.ipcRenderer.send("reset_sign_out");
        }
      }, " ", "Sign out"), /*#__PURE__*/React.createElement("img", {
        src: require("../img/need_help.png"),
        style: {
          bottom: 20,
          right: 20,
          position: "fixed",
          cursor: "pointer"
        },
        onClick: function onClick() {
          return window.ipcRenderer.send("open_chat_support");
        }
      }));
    } else {
      var _window3, _window3$ipcRenderer;
      var _sendConsoleEvent = (_window3 = window) === null || _window3 === void 0 ? void 0 : (_window3$ipcRenderer = _window3.ipcRenderer) === null || _window3$ipcRenderer === void 0 ? void 0 : _window3$ipcRenderer.send("send_console_event", "Reload Workfolio Error logged");
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
        style: {
          display: "grid",
          placeItems: "center",
          height: "100vh"
        }
      }, /*#__PURE__*/React.createElement(Spinner, {
        variant: "primary",
        animation: "border",
        role: "status",
        style: {
          marginTop: "40%"
        }
      }, /*#__PURE__*/React.createElement("span", {
        className: "sr-only"
      }, "Loading..."))));
    }
  }
  var siteName = findIsWorkfolioSite(); // Workfolio or Rebrand domain name

  var siteNameWith1stLetterCaps = siteName.charAt(0).toUpperCase() + siteName.slice(1);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Helmet, null, /*#__PURE__*/React.createElement("title", null, pageHeader ? "".concat(siteNameWith1stLetterCaps, " | ").concat(pageHeader, " | ").concat(user === null || user === void 0 ? void 0 : user.displayName) : siteNameWith1stLetterCaps)), /*#__PURE__*/React.createElement(FilterContext.Provider, {
    value: {
      startDate: startDate,
      endDate: endDate,
      setDatesFilter: setDatesFilter,
      organisationId: organisationId,
      setOrganisationId: setOrganisationId,
      teamId: teamId,
      setTeamId: setTeamId,
      teamName: teamName,
      setTeamName: setTeamName,
      setSearch: setSearch,
      search: search,
      organisationSettings: organisationSettings,
      setOrganisationSettings: setOrganisationSettings,
      organisationTeamAndRole: organisationTeamData === null || organisationTeamData === void 0 ? void 0 : organisationTeamData.organisationTeams,
      role: role,
      organisationUserCount: organisationUserCount,
      setOrganisationUserCount: setOrganisationUserCount,
      organisationBilling: organisationBilling,
      mobileViewSideMenu: mobileViewSideMenu,
      setMobileViewSideMenu: setMobileViewSideMenu,
      isMobileView: isMobileView,
      from: from,
      organisationMenuList: organisationMenuList,
      leaveSettingsUser: leaveSettingsUser,
      organisationStatus: organisationStatus,
      timezoneFilter: timezoneFilter,
      setTimezoneFilter: setTimezoneFilter
    }
  }, /*#__PURE__*/React.createElement(SearchContext.Provider, {
    value: {
      setSearch: setSearch,
      search: search
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: classNames("root-layout", from, {
      "has-second-menu": showSecondMenu
    }, {
      "root-layout-mobile-with-menu": isMobileView && mobileViewSideMenu && from === "web",
      "root-layout-mobile-without-menu": isMobileView && !mobileViewSideMenu && from === "web"
    }),
    style: {
      gridTemplateColumns: from === "desktop" && viewMode === "widget" ? "none" : from === "desktop" ? "217px minmax(0, 1fr)" : null
    }
  }, mobileViewSideMenu || from === "desktop" && viewMode === "fullScreen" ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Menu, _extends({}, linkProps, {
    menus: menus,
    activeMenu: firstMenu,
    organisationSettings: organisationSettings,
    organisationTeamAndRole: organisationTeamData === null || organisationTeamData === void 0 ? void 0 : organisationTeamData.organisationTeams,
    organisationMenuList: organisationMenuList,
    organisationId: organisationId,
    teamId: teamId,
    user: user,
    viewMode: viewMode,
    setViewMode: setViewMode,
    handleFullScreen: handleFullScreen,
    from: from,
    header: /*#__PURE__*/React.createElement("div", {
      className: "sidebar-wrapper-header"
    }, from === "web" ? /*#__PURE__*/React.createElement(LinkComponent, _extends({}, _defineProperty({}, linkAttribute, "/"), {
      className: "d-block sidebar-wrapper-header-logo"
    }), user !== null && user !== void 0 && user.organisations[0].logoUrl ? /*#__PURE__*/React.createElement("img", {
      src: user === null || user === void 0 ? void 0 : user.organisations[0].logoUrl,
      className: "organisation-info-profile-images"
    }) : siteNameWith1stLetterCaps) : /*#__PURE__*/React.createElement("span", {
      className: "d-block sidebar-wrapper-header-logo"
    }, siteNameWith1stLetterCaps)),
    manualTimeCount: manualTimeCountData === null || manualTimeCountData === void 0 ? void 0 : (_manualTimeCountData$ = manualTimeCountData.getReviewManualTimeCount) === null || _manualTimeCountData$ === void 0 ? void 0 : _manualTimeCountData$.unreviewedManualTime,
    role: role,
    menuType: "first-menu",
    organisationBilling: organisationBilling,
    moblieSideMenu: moblieSideMenu,
    organisationDetailsLoading: organisationDetailsLoading,
    organisationTeamLoading: organisationTeamLoading,
    leaveSettingsApprovedData: leaveSettingsApprovedData === null || leaveSettingsApprovedData === void 0 ? void 0 : leaveSettingsApprovedData.leaveSettingsApprovedUserList
    // footer={<MenuFooter {...linkProps} organisationDetails={organisationDetailsData?.organisationDetails} />}
    ,
    organisationStatus: organisationStatus
  })), showSecondMenu && secondMenus[showSecondMenu] ? /*#__PURE__*/React.createElement(Menu, _extends({}, linkProps, {
    menus: secondMenus[showSecondMenu],
    parentMenu: firstMenu,
    activeMenu: secondMenu,
    organisationSettings: organisationSettings,
    organisationMenuList: organisationMenuList,
    organisationId: organisationId,
    teamId: teamId,
    user: user,
    viewMode: viewMode,
    handleFullScreen: handleFullScreen,
    from: from,
    header: /*#__PURE__*/React.createElement("div", {
      className: "sidebar-wrapper-header"
    }, /*#__PURE__*/React.createElement("h5", null, showSecondMenu === "settings" ? "Settings" : "Reports")),
    manualTimeCount: manualTimeCountData === null || manualTimeCountData === void 0 ? void 0 : (_manualTimeCountData$2 = manualTimeCountData.getReviewManualTimeCount) === null || _manualTimeCountData$2 === void 0 ? void 0 : _manualTimeCountData$2.unreviewedManualTime,
    role: role,
    menuType: "second-menu",
    organisationBilling: organisationBilling,
    moblieSideMenu: moblieSideMenu,
    windowSize: windowSize,
    organisationDetailsLoading: organisationDetailsLoading,
    organisationTeamLoading: organisationTeamLoading,
    leaveSettingsApprovedData: leaveSettingsApprovedData === null || leaveSettingsApprovedData === void 0 ? void 0 : leaveSettingsApprovedData.leaveSettingsApprovedUserList,
    organisationStatus: organisationStatus
  })) : null) : null, /*#__PURE__*/React.createElement("div", {
    className: "root-layout-page",
    style: {
      backgroundColor: from === "desktop" && organisationSettings.projectManagementFeature && (!pageHeader || pageHeader === "Overview") ? "#ffffff" : null
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "page-content-wrapper-header"
  }, /*#__PURE__*/React.createElement("div", {
    className: "page-content-wrapper-header-name-section"
  }, window.innerWidth > 822 && isWindow && from === "web" || from === "desktop" ? null : /*#__PURE__*/React.createElement(GoThreeBars, {
    onClick: moblieSideMenu
  }), pageHeader === "Payroll Calculator" ? /*#__PURE__*/React.createElement("h5", {
    className: "page-content-wrapper-header-name"
  }, pageHeader, /*#__PURE__*/React.createElement("sup", {
    className: "page-content-wrapper-header-name-sup"
  }, "Beta")) : pageHeader === "Manage Employees" ? /*#__PURE__*/React.createElement("h5", {
    className: "page-content-wrapper-header-name"
  }, "Employees") : /*#__PURE__*/React.createElement("h5", {
    className: "page-content-wrapper-header-name"
  }, pageHeader)), /*#__PURE__*/React.createElement(Header, _extends({
    activeMenus: activeMenus,
    organisationTeams: organisationTeams
  }, linkProps, {
    organisationDetails: organisationDetailsData === null || organisationDetailsData === void 0 ? void 0 : organisationDetailsData.organisationDetails,
    setSearch: setSearch,
    search: search,
    viewMode: viewMode,
    setViewMode: setViewMode,
    handleFullScreen: handleFullScreen,
    from: from,
    history: otherProps.history,
    rolesDetails: rolesDetails,
    organisationTeamData: organisationTeamData,
    getRoleData: getRoleData
  }))), /*#__PURE__*/React.createElement("div", {
    className: "page-content-wrapper-content"
  }, children)), from === "web" && windowSize > 768 && (role == "Admin" || role == "Head") ? /*#__PURE__*/React.createElement(Tour, {
    steps: role === "Admin" ? tourStepsForAdmin : tourStepsForHead,
    isOpen: isTourOpen,
    onRequestClose: function onRequestClose() {
      userTourStop(user.userId);
      setIsTourOpen(false);
    },
    disableInteraction: true,
    className: "workfolio-react-tour"
  }) : null))));
};
export default Sidemenu;
var Menu = /*#__PURE__*/React.memo(function Menu(props) {
  var menus = props.menus,
    header = props.header,
    organisationSettings = props.organisationSettings,
    organisationMenuList = props.organisationMenuList,
    organisationId = props.organisationId,
    teamId = props.teamId,
    user = props.user,
    organisationTeamAndRole = props.organisationTeamAndRole,
    from = props.from,
    viewMode = props.viewMode,
    handleFullScreen = props.handleFullScreen,
    manualTimeCount = props.manualTimeCount,
    role = props.role,
    menuType = props.menuType,
    organisationBilling = props.organisationBilling,
    moblieSideMenu = props.moblieSideMenu,
    windowSize = props.windowSize,
    organisationDetailsLoading = props.organisationDetailsLoading,
    organisationTeamLoading = props.organisationTeamLoading,
    leaveSettingsApprovedData = props.leaveSettingsApprovedData,
    organisationStatus = props.organisationStatus,
    otherProps = _objectWithoutProperties(props, _excluded2);

  // const teamDetails = organisationTeamAndRole?.find((teamData) => teamData.team.teamId === teamId) || {};
  // const role = teamDetails?.role?.roleName;

  var leaveApprovedSettings = leaveSettingsApprovedData && leaveSettingsApprovedData !== null && leaveSettingsApprovedData !== void 0 && leaveSettingsApprovedData.approvedList.length ? leaveSettingsApprovedData === null || leaveSettingsApprovedData === void 0 ? void 0 : leaveSettingsApprovedData.approvedList.find(function (o) {
    return o.userId === user.userId;
  }) : null;
  var trialDays = 0;
  if (organisationBilling !== null && organisationBilling !== void 0 && organisationBilling.isTrial) {
    trialDays = Math.ceil(moment.duration(moment(Number(organisationBilling === null || organisationBilling === void 0 ? void 0 : organisationBilling.trialEnd)).diff(moment())).asDays());
  }
  var appVersion = window.navigator.appVersion.split("Workfolio/").pop().split(" ")[0];
  var MenuHeaderChecking = function MenuHeaderChecking(menuHeader) {
    // else if (
    //   menuHeader === "Proof of work" &&
    //   !organisationSettings.allowMemberToAccessScreenCapture &&
    //   role === "Member" &&
    //   !organisationSettings.employeesCanAnalyzeTheirOwnData &&
    //   role === "Member" &&
    //   !organisationSettings.screenCapture
    // ) {
    //   return false;
    // }

    if (menuHeader === "Reviews" && !organisationSettings.trackAppsAndWebsites) {
      return false;
    } else if (menuHeader === "Project & Task" && !organisationSettings.projectManagementFeature) {
      return false;
    } else if (menuHeader === "Leave Management" && organisationSettings.leaveManagementFeature !== undefined && !organisationSettings.leaveManagementFeature) {
      return false;
    } else if (menuHeader === "Configuration" && !leaveApprovedSettings && role == "Member") {
      return false;
    } else if (menuHeader === "Finance" && (organisationBilling.planId != "83844da8-71e8-4e94-b6ac-aaff5d8a858c" || !organisationSettings.enableSalaryCalculator)) {
      return false;
    }

    // else if (
    //   (menuHeader === "Finance" &&
    //     !organisationSettings.enableSalaryCalculator &&
    //     organisationBilling.planId == "83844da8-71e8-4e94-b6ac-aaff5d8a858c") ||
    //   (menuHeader === "Finance" &&
    //     organisationSettings.enableSalaryCalculator &&
    //     organisationBilling.planId != "83844da8-71e8-4e94-b6ac-aaff5d8a858c")
    // ) {
    //   return false;
    // }
    return true;
  };
  var ShowMenuChecking = function ShowMenuChecking(menuItem) {
    var _menuItem$role;
    var siteName = findIsWorkfolioSite();
    if ((menuItem.name === "Screenshots" || menuItem.name === "Timelapse Videos") && !organisationSettings.allowMemberToAccessScreenCapture && role === "Member" || menuItem.name === "Timelapse Videos" && !organisationSettings.allowMemberToAccessTimelapseVideo && role === "Member" || menuItem.name === "Screenshots" && !organisationSettings.allowHeadToAccessTheirTeamMemberScreenCaptureAndTimelapseVideo && !organisationSettings.allowMemberToAccessScreenCapture && role === "Head" || menuItem.name === "Screenshots" && !organisationSettings.screenCapture && role === "Member" || menuItem.name === "My Projects" && !organisationSettings.projectManagementFeature || menuItem.name === "Work History" && !organisationSettings.projectManagementFeature || menuItem.name === "Task Overview" && !organisationSettings.projectManagementFeature || menuItem.name === "My Tasks" && !organisationSettings.projectManagementFeature || menuItem.name === "Manual Tasks" && (!organisationSettings.projectManagementFeature || !(organisationSettings !== null && organisationSettings !== void 0 && organisationSettings.manualTimeFeature)) || menuItem.name === "Review Manual Time" && (!organisationSettings.projectManagementFeature || !(organisationSettings !== null && organisationSettings !== void 0 && organisationSettings.manualTimeFeature)) || (menuItem.name === "Apps History" || menuItem.name === "Review Apps" || menuItem.name === "Apps Summary") && !organisationSettings.trackAppsAndWebsites || menuItem.name === "Offscreen Task" && !organisationSettings.offlineTask || (menuItem.name === "Timesheet" || menuItem.name === "Apps History") && !organisationSettings.allowMemberToAccessTimesheet && role === "Member" || menuItem.name === "Timelapse Videos" && !organisationSettings.screenCapture || menuItem.name === "Project Report" && !organisationSettings.projectManagementFeature || menuItem.name === "Manual Time Report" && !(organisationSettings !== null && organisationSettings !== void 0 && organisationSettings.manualTimeFeature) ||
    //   ||
    // (!organisationSettings.projectManagementFeature && menuItem.name != "My Projects" && menuItem.name !== "Work History")
    menuItem.name === "Manual Time" && !(organisationSettings !== null && organisationSettings !== void 0 && organisationSettings.manualTimeFeature) || menuItem.name === "Manage Leave" && (!organisationSettings.leaveManagementFeature || organisationSettings.leaveManagementFeature !== undefined && organisationSettings.leaveManagementFeature == true) && !leaveApprovedSettings && leaveApprovedSettings == undefined && (role == "Member" || role == "Head") || menuItem.name === "Leave Summary" && (!organisationSettings.leaveManagementFeature || organisationSettings.leaveManagementFeature !== undefined && organisationSettings.leaveManagementFeature == true) && !leaveApprovedSettings && leaveApprovedSettings == undefined && (role == "Member" || role == "Head") || menuItem.name === "Manage Leave" && !organisationSettings.leaveManagementFeature && organisationSettings.leaveManagementFeature !== undefined && role == "Admin" || menuItem.name === "Leave Summary" && !organisationSettings.leaveManagementFeature && organisationSettings.leaveManagementFeature !== undefined && role == "Admin" || menuItem.name === "Settings" && !leaveApprovedSettings && role == "Member" || menuItem.name === "Leave Settings" && !leaveApprovedSettings && !organisationSettings.leaveManagementFeature && organisationSettings.leaveManagementFeature !== undefined && (role == "Member" || role == "Head") || menuItem.name === "Leave Settings" && !organisationSettings.leaveManagementFeature && organisationSettings.leaveManagementFeature !== undefined && role == "Admin" || menuItem.name === "Review Apps" && !organisationSettings.allowHeadsToReviewApps && role == "Head" ||
    // (menuItem.name === "Screenshots" &&
    //   !organisationSettings.allowMemberToAccessScreenCapture &&
    //   !organisationSettings.allowHeadToAccessTheirTeamMemberScreenCaptureAndTimelapseVideo &&
    //   role == "Head") ||
    menuItem.name === "Timelapse Videos" && (!organisationSettings.allowMemberToAccessTimelapseVideo || !organisationSettings.allowMemberToAccessScreenCapture) && !organisationSettings.allowHeadToAccessTheirTeamMemberScreenCaptureAndTimelapseVideo && role == "Head" || menuItem.name === "Apply Leave" && !organisationSettings.leaveManagementFeature && organisationSettings.leaveManagementFeature !== undefined || menuItem.name === "Manage Holiday" && !organisationSettings.leaveManagementFeature && organisationSettings.leaveManagementFeature !== undefined ||
    // (menuItem.name === "API Token" && !organisationSettings.enableApiAccess) ||
    menuItem.name === "Real Time Alert" && organisationId != "f2c9e240-4e71-11eb-9784-794f853f90e2" && organisationId != "5da90b00-1205-11ee-99eb-6f59a4034ddc" && organisationId != "35fcc020-e2ec-11ee-9c92-a7c3dd681c18" && organisationId != "0b05daf0-1a59-11f0-ab0d-8dc7aeb69888" && organisationBilling.planId != "83844da8-71e8-4e94-b6ac-aaff5d8a858c" || menuItem.name === "Real Time Alert" && (organisationSettings.enableRealTimeAlert == false || !organisationSettings.enableRealTimeAlert) && organisationBilling.planId == "83844da8-71e8-4e94-b6ac-aaff5d8a858c" && organisationId != "5da90b00-1205-11ee-99eb-6f59a4034ddc" && organisationId != "35fcc020-e2ec-11ee-9c92-a7c3dd681c18" && organisationId != "0b05daf0-1a59-11f0-ab0d-8dc7aeb69888" || !organisationSettings.enableApiAccess && menuItem.name === "API Token" || organisationBilling.planId != "83844da8-71e8-4e94-b6ac-aaff5d8a858c" && menuItem.name === "Payroll Calculator" || !organisationSettings.enableSalaryCalculator && menuItem.name === "Payroll Calculator") {
      return false;
    }

    // enableApiAccess
    //     enableRealTimeAlert
    //  else if (
    //   (!organisationSettings.enableSalaryCalculator &&
    //     menuItem.name === "Payroll Calculator" &&
    //     organisationBilling.planId == "83844da8-71e8-4e94-b6ac-aaff5d8a858c") ||
    //   (menuItem.name === "Payroll Calculator" &&
    //     organisationBilling.planId != "83844da8-71e8-4e94-b6ac-aaff5d8a858c") ||
    //   (menuItem.name === "Input Activity Report" &&
    //     organisationBilling.planId != "83844da8-71e8-4e94-b6ac-aaff5d8a858c") ||
    //   (!organisationSettings.keyStrokeCounter &&
    //     !organisationSettings.mouseTracker &&
    //     menuItem.name === "Input Activity Report" &&
    //     organisationBilling.planId != "83844da8-71e8-4e94-b6ac-aaff5d8a858c") ||
    //   (menuItem.name === "API Token" && organisationBilling.planId != "83844da8-71e8-4e94-b6ac-aaff5d8a858c")
    // ) {
    //   return false;
    // }
    else if ((menuItem === null || menuItem === void 0 ? void 0 : (_menuItem$role = menuItem.role) === null || _menuItem$role === void 0 ? void 0 : _menuItem$role.indexOf(role === null || role === void 0 ? void 0 : role.toLowerCase())) == -1) {
      return false;
    } else if (siteName !== "workfolio" && (menuItem.path === "email-reports" || menuItem.path === "api-token")) {
      return false;
    } else if (menuItem.name === "Activity" && !organisationSettings.projectManagementFeature) {
      return false;
    }
    return true;
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "root-layout-menu"
  }, header, /*#__PURE__*/React.createElement("div", {
    className: classNames("sidebar-wrapper-content", {
      "has-footer": Boolean(false)
    }, {
      "sidebar-wrapper-content-trial": menuType === "first-menu" && (organisationBilling.isTrial || (organisationBilling === null || organisationBilling === void 0 ? void 0 : organisationBilling.freeStoragePercentage) >= 50) && window.innerWidth > 768
    })
  }, organisationDetailsLoading || organisationTeamLoading ? /*#__PURE__*/React.createElement(Loader, null) : menus.map(function (menu, menuIndex) {
    var headerStatus = menu.menu.some(function (menuItem) {
      var _menuItem$role2;
      return (menuItem === null || menuItem === void 0 ? void 0 : (_menuItem$role2 = menuItem.role) === null || _menuItem$role2 === void 0 ? void 0 : _menuItem$role2.indexOf(role === null || role === void 0 ? void 0 : role.toLowerCase())) > -1;
    });
    return /*#__PURE__*/React.createElement("div", {
      key: "menu-".concat(menuIndex),
      className: "sidebar-wrapper-content-parent"
    }, menu.header && headerStatus && MenuHeaderChecking(menu.header) ? menu.header == "Finance" ? /*#__PURE__*/React.createElement("div", {
      className: "sidebar-wrapper-content-parent-name"
    }, menu.header, /*#__PURE__*/React.createElement("sup", {
      "class": "page-content-wrapper-header-name-sup-project"
    }, "Beta")) : /*#__PURE__*/React.createElement("div", {
      className: "sidebar-wrapper-content-parent-name"
    }, menu.header) : null, menu.menu.map(function (menuItem, menuItemIndex) {
      var menuItemValue = _objectSpread({}, menuItem);
      if (menuItemValue.name === "Settings" && menuItemValue.path === "settings/manage-teams" && role === "Head" || menuItemValue.name === "Settings" && menuItemValue.path === "settings/manage-teams" && (organisationBilling === null || organisationBilling === void 0 ? void 0 : organisationBilling.planStatus) === "stopped" || menuItemValue.name === "Settings" && menuItemValue.path === "settings/manage-teams" && organisationStatus === "inactive") {
        menuItemValue.path = "settings/manage-employees";
      } else if (menuItemValue.name === "Settings" && menuItemValue.path === "settings/manage-teams" && role === "Member") {
        menuItemValue.path = "settings/leave-settings";
      }
      if ((role === "Member" || role === "Head") && leaveApprovedSettings && menuItemValue.path === "view-holiday") {
        menuItemValue.path = "manage-holiday";
        menuItemValue.name = "Manage Holiday";
      }
      if (role === "Head" && !leaveApprovedSettings && menuItemValue.path === "manage-holiday") {
        menuItemValue.path = "view-holiday";
        menuItemValue.name = "View Holiday";
      }

      //icon: ƒ MdSettings(props)
      // name: "Settings"
      // pageHeader: Array(1)
      // 0: {userTeam: "Designer", day: "Today"}
      // length: 1
      // __proto__: Array(0)
      // path: "settings/manage-teams"
      // role: (2) ["admin", "head"]
      // secondMenu: true
      // tourClassName: ""

      if (ShowMenuChecking(menuItem)) {
        return /*#__PURE__*/React.createElement(MenuItem, _extends({
          key: "menu-".concat(menuIndex, "-").concat(menuItemIndex)
        }, otherProps, menuItemValue, {
          manualTimeCount: manualTimeCount,
          role: role,
          moblieSideMenu: moblieSideMenu,
          from: from
        }));
      }
    }));
  })), menuType === "first-menu" && (organisationBilling.isTrial || (organisationBilling === null || organisationBilling === void 0 ? void 0 : organisationBilling.freeStoragePercentage) >= 50) && window.innerWidth > 768 ? /*#__PURE__*/React.createElement("div", {
    className: "sidebar-wrapper-content-trial-content"
  }, /*#__PURE__*/React.createElement("label", null, " ", (organisationBilling === null || organisationBilling === void 0 ? void 0 : organisationBilling.freeStoragePercentage) >= 50 ? "".concat(organisationBilling === null || organisationBilling === void 0 ? void 0 : organisationBilling.freeStoragePercentage, "% storage used") : trialDays <= 0 ? "Trial Expired" : Number(trialDays) === 1 ? "Trial ends today" : "Trial: ".concat(trialDays > 1 ? "".concat(trialDays + " days ") : "".concat(trialDays + " day "), "\n              remaining"))) : null, from !== "web" && viewMode === "fullScreen" ? /*#__PURE__*/React.createElement("p", {
    style: {
      position: "relative",
      bottom: menuType === "first-menu" && (organisationBilling.isTrial || (organisationBilling === null || organisationBilling === void 0 ? void 0 : organisationBilling.freeStoragePercentage) >= 50) ? "12%" : "8%",
      textAlign: "center",
      fontSize: 14
    }
  }, "Version ", appVersion, " ", /*#__PURE__*/React.createElement("br", null), "Copyright \xA9 2021 Workfolio", " ") : null);
});
function MenuItem(props) {
  var _organisationTeamAndR, _organisationTeamAndR2;
  var LinkComponent = props.linkComponent,
    linkAttribute = props.linkAttribute,
    parentMenu = props.parentMenu,
    activeMenu = props.activeMenu,
    path = props.path,
    name = props.name,
    Icon = props.icon,
    organisationTeamAndRole = props.organisationTeamAndRole,
    tourClassName = props.tourClassName,
    manualTimeCount = props.manualTimeCount,
    moblieSideMenu = props.moblieSideMenu,
    role = props.role,
    from = props.from;

  //const isSelected = path.includes(activeMenu);
  var isSelected = path == activeMenu ? true : false;
  var selectedMenu = useMemo(function () {
    return [parentMenu, path].filter(function (f) {
      return f;
    }).join("/");
  }, [parentMenu, path]);
  var componentProps = useMemo(function () {
    return _defineProperty({}, linkAttribute, "/".concat(selectedMenu));
  }, [linkAttribute, selectedMenu]);
  var splitString = name.split(" ");
  var names = name;
  if (name === "My Team" && (organisationTeamAndRole === null || organisationTeamAndRole === void 0 ? void 0 : (_organisationTeamAndR = organisationTeamAndRole[0]) === null || _organisationTeamAndR === void 0 ? void 0 : _organisationTeamAndR.roleName) === "Admin") {
    names = splitString[1];
  } else if (name === "My Projects" && (organisationTeamAndRole === null || organisationTeamAndRole === void 0 ? void 0 : (_organisationTeamAndR2 = organisationTeamAndRole[0]) === null || _organisationTeamAndR2 === void 0 ? void 0 : _organisationTeamAndR2.roleName) === "Admin") {
    names = splitString[1];
  }
  return /*#__PURE__*/React.createElement(LinkComponent, _extends({
    className: classNames("sidebar-wrapper-content-navbar-list", {
      selected: isSelected
    }, tourClassName),
    onClick: name != "Share a Testimonial" && name != "Download App" ? from === "desktop" ? function (e) {
      e.preventDefault();
      window.ipcRenderer.send("open_external_link", "https://app.getworkfolio.com/".concat(path));
    } : function () {
      return moblieSideMenu(names);
    } : function (e) {
      e.preventDefault();
      window.open(path, "_blank").focus();
    }
  }, componentProps), /*#__PURE__*/React.createElement(Icon, {
    className: classNames("sidebar-wrapper-content-navbar-list-item-icon", {
      "sidebar-wrapper-content-navbar-list-item-icon-Videos": name === "Timelapse Videos",
      "sidebar-wrapper-content-navbar-list-item-icon-over-time": name === "Over Time Report"
    })
  }), /*#__PURE__*/React.createElement("div", {
    className: "sidebar-wrapper-content-navbar-list-item-name"
  }, name === "Review Manual Time" ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", null, "Manual Time "), /*#__PURE__*/React.createElement("span", {
    className: "sidebar-wrapper-content-navbar-list-item-name-review-badge"
  }, Number(manualTimeCount) > 0 ? manualTimeCount : null)) : names));
}
export var MenuFooter = /*#__PURE__*/React.memo(function MenuFooter(props) {
  var LinkComponent = props.linkComponent,
    linkAttribute = props.linkAttribute,
    organisationDetails = props.organisationDetails,
    setTeamId = props.setTeamId,
    from = props.from,
    viewMode = props.viewMode,
    setViewMode = props.setViewMode,
    handleFullScreen = props.handleFullScreen,
    history = props.history;
  var _React$useContext = React.useContext(UserContext),
    user = _React$useContext.user,
    setUser = _React$useContext.setUser;
  var tracking = React.useContext(TrackingContext);
  var _ref7 = tracking || {},
    task = _ref7.task,
    onStop = _ref7.onStop;
  var onSignOut = function onSignOut() {
    if (from !== "desktop") {
      var _localStorage2, _localStorage3, _localStorage4, _localStorage5;
      (_localStorage2 = localStorage) === null || _localStorage2 === void 0 ? void 0 : _localStorage2.removeItem("token");
      (_localStorage3 = localStorage) === null || _localStorage3 === void 0 ? void 0 : _localStorage3.removeItem("timesheetParameter");
      localStorage.removeItem("timezone");
      (_localStorage4 = localStorage) === null || _localStorage4 === void 0 ? void 0 : _localStorage4.removeItem("signupUrlParams");
      (_localStorage5 = localStorage) === null || _localStorage5 === void 0 ? void 0 : _localStorage5.removeItem("signupAttribution");
      if (task) {
        onStop === null || onStop === void 0 ? void 0 : onStop("stop", "sign_out");
      }
      setTimeout(function () {
        setUser(null);
      }, 100);
    } else {
      onStop === null || onStop === void 0 ? void 0 : onStop("stop", "reset_sign_out");
    }
  };
  var displayName = (user === null || user === void 0 ? void 0 : user.displayName) || "Menu";
  return /*#__PURE__*/React.createElement("div", {
    className: "sidebar-wrapper-user-profile"
  }, /*#__PURE__*/React.createElement(DropdownMenu, {
    drop: "down"
  }, /*#__PURE__*/React.createElement(DropdownSubMenu, {
    title: /*#__PURE__*/React.createElement("div", null, (user === null || user === void 0 ? void 0 : user.profileUrl) === null || (user === null || user === void 0 ? void 0 : user.profileUrl) === "" ? /*#__PURE__*/React.createElement("div", {
      className: "sidebar-wrapper-user-profile-avatar"
    }, displayName.charAt(0).toUpperCase()) : /*#__PURE__*/React.createElement("div", {
      className: "header-menu-card-avatar-profile"
    }, /*#__PURE__*/React.createElement("img", {
      alt: "Workfolio",
      src: user === null || user === void 0 ? void 0 : user.profileUrl,
      className: "header-menu-card-avatar-profile-img"
    }))),
    key: "profile-menu",
    popupClassName: "user-profile-submenu"
  }, /*#__PURE__*/React.createElement(DropdownMenuItem, {
    key: "profile-menu-item",
    className: "user-profile-submenu-item",
    disabled: true,
    id: "organisation-filter"
  }, /*#__PURE__*/React.createElement("label", {
    className: "text-muted small"
  }, "Organisation"), /*#__PURE__*/React.createElement(OrganisationFilter, {
    organisationDetails: organisationDetails,
    setTeamId: setTeamId
  })), /*#__PURE__*/React.createElement(DropdownDivider, null), personalDataTabs.map(function (tab, tabIndex) {
    if (from === "desktop" && tab.id === "account-settings-link" || from === "desktop" && tab.id === "workfolio-affiliates") {
      return null;
    }
    var linkProps = _defineProperty(_defineProperty({}, linkAttribute, tab.path), "key", tab.path);
    var item = /*#__PURE__*/React.createElement(LinkComponent, _extends({
      onClick: from === "desktop" && viewMode === "widget" ? function () {
        setViewMode("fullScreen"), handleFullScreen();
      } : null
    }, linkProps), tab.name);
    if (tab.type === "button") {
      var onClick;
      if (tab.name === "Sign Out") {
        onClick = onSignOut;
      } else if (tab.name === "Send bug report") {
        if (from === "web") {
          item = null;
          return true;
        }
        onClick = function onClick() {
          return window.ipcRenderer.send("send_log", user === null || user === void 0 ? void 0 : user.emailId);
        };
      } else if (tab.id === "workfolio-affiliates") {
        var origin = window.location.origin;
        if (from != "web") {
          item = null;
          return true;
        }
        onClick = function onClick() {
          return window.open(origin ? origin + "/workfolio-affiliates" : "https://app.getworkfolio.com/workfolio-affiliates", "_blank");
        };
      } else {
        onClick = tab.onClick;
      }
      item = /*#__PURE__*/React.createElement("a", {
        href: "javascript:void(0)",
        onClick: onClick
      }, tab.name);
    }
    return /*#__PURE__*/React.createElement(DropdownMenuItem, {
      id: tab.id,
      key: "1-".concat(tabIndex + 2),
      className: "user-profile-submenu-item",
      disabled: tab.type === "button"
    }, item);
  }))));
});
var OrganisationFilter = /*#__PURE__*/React.memo(function OrganisationFilter(props) {
  var _useContext2 = useContext(FilterContext),
    organisationId = _useContext2.organisationId,
    setOrganisationId = _useContext2.setOrganisationId;
  var organisationDetails = props.organisationDetails,
    setTeamId = props.setTeamId;
  var value = React.useMemo(function () {
    if (!organisationDetails) return null;
    return organisationDetails.find(function (t) {
      return t.organisationId === organisationId;
    });
  }, [organisationId]);
  if (!organisationDetails) return null;
  return (
    /*#__PURE__*/
    // <Dropdown onSelect={setOrganisationId}>
    React.createElement(Dropdown, {
      onSelect: function onSelect(evt) {
        if (organisationId !== evt) {
          setOrganisationId(evt);
          setTeamId(null);
        }
      }
    }, /*#__PURE__*/React.createElement(Dropdown.Toggle, {
      as: CustomToggle
    }, value === null || value === void 0 ? void 0 : value.organisationName), /*#__PURE__*/React.createElement(Dropdown.Menu, null, organisationDetails.map(function (item, index) {
      return /*#__PURE__*/React.createElement(Dropdown.Item, {
        key: "org-".concat(index),
        eventKey: item.organisationId
      }, item.organisationName);
    })))
  );
});